import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ShieldOff } from 'lucide-react';
import { buildAdminUrl } from '@/lib/workspace';
import type { Account } from '@/types/icrop';

interface WorkspaceDeniedPageProps {
  account: Account;
}

export function WorkspaceDeniedPage({ account }: WorkspaceDeniedPageProps) {
  const { signOut } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <div className="flex justify-center mb-4">
            <ShieldOff className="h-12 w-12 text-destructive" />
          </div>
          <CardTitle className="text-2xl">Access denied</CardTitle>
          <CardDescription>
            You don't have access to <strong>{account.name}</strong>. Ask the workspace
            administrator to add you, or sign in with an account that has access.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-2">
          <Button asChild variant="outline">
            <a href={buildAdminUrl('/login')}>Sign in with a different account</a>
          </Button>
          <Button variant="ghost" onClick={() => signOut()}>
            Sign out
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
